import { Link } from "react-router-dom";
import { Editable } from "@/components/Editable";

export default function Footer() {
  return (
    <footer className="mt-16 border-t" style={{ backgroundColor: "var(--arc-card)" }}>
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-4 py-8 sm:px-6 md:flex-row md:items-center md:justify-between">
        <div className="font-serif-arc text-sm font-black tracking-tight">THE ARCHIVES</div>
        <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm" style={{ color: "var(--arc-text-2)" }}>
          <Link to="/about" data-testid="footer-about" className="hover:underline">About</Link>
          <Link to="/disclaimer" data-testid="footer-disclaimer" className="hover:underline">Disclaimer</Link>
          <Link to="/privacy" data-testid="footer-privacy" className="hover:underline">Privacy</Link>
          <Link to="/contact" data-testid="footer-contact" className="hover:underline">Contact</Link>
        </nav>
        <div className="text-sm" style={{ color: "var(--arc-text-2)" }}>© The Archives</div>
      </div>
      <div className="border-t px-4 py-4 text-center text-xs" style={{ color: "var(--arc-text-2)" }}>
        <Editable id="footer.note" as="p" fallback="Unofficial community project." />
        <Editable id="footer.bias" as="p" fallback="The Archives has absolutely no bias whatsoever." className="mt-1 italic opacity-80" />
      </div>
    </footer>
  );
}
